import type { MatchData, ModalData } from '@presentation/components';

export interface MtApplicationsBuyerPayModalControllerData {
  modal: ModalData;
  match: MatchData;
  onConfirm: () => void;
}

export interface MtApplicationsBuyerPayModalControllerProps
  extends MtApplicationsBuyerPayModalControllerData {}
